export enum Country {
  Spain = 'es',
  France = 'fr',
  Germany = 'de',
  Italy = 'it',
  Portugal = 'pt',
  // add more countries
}
